import { useState } from 'react';
import { api } from '../../lib/api';
import { type EdgeState, errText, failOf, noteOf, pickText } from './common';

const WORD = 'ÁTÁLLÁS';

// Átállás-modal: ellenőrző lista + a megerősítő szó begépelése; csak ezen át megy az edge éles (80/443) módba.
export function EdgeCutover({ edge, onClose, onDone }: { edge: EdgeState; onClose: () => void; onDone: (result: string) => void }) {
  const edgeOk = Boolean(edge.installed && edge.running && edge.mode !== 'prod');
  const [checks, setChecks] = useState([false, false, false]);
  const [word, setWord] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const ready = edgeOk && checks.every(Boolean) && word.trim() === WORD;
  const ITEMS = [
    'Minden domaint kipróbáltam a teszt-porton (https://<domain>:8443) — a Weboldalak kártyái zöldek.',
    'Tudom: az OpenResty-konténer leáll, a 80/443-at az edge veszi át; az új tanúsítványok kérése pár percig tarthat.',
    'Van visszaút: a „Visszaút” gomb másodpercek alatt visszaállítja az OpenResty-t és az edge teszt-módját.',
  ];

  const go = async () => {
    if (!ready) return;
    setBusy(true); setErr('');
    try { const r = await api<unknown>('/api/n4/edge/cutover', { method: 'POST', body: JSON.stringify({ confirm: true }) }); failOf(r); onDone(noteOf(r) || pickText(r, 'output', 'log', 'message') || 'Átállás kész: az edge élesben fut (80/443).'); }
    catch (e) { setErr(errText(e, 'Átállás')); } finally { setBusy(false); }
  };

  return (
    <div className="a-overlay fixed inset-0 z-40 flex items-start justify-center overflow-auto p-4 pt-16" onClick={() => !busy && onClose()}>
      <div className="a-panel a-pad a-modal-in w-full max-w-xl" onClick={(e) => e.stopPropagation()}>
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-[20px] text-neutral-100">Átállás élesre</h3>
          <span role="button" tabIndex={0} className="cursor-pointer px-2 text-neutral-500 hover:text-neutral-200" onClick={() => !busy && onClose()}>✕</span>
        </div>
        <p className="a-sub" style={{ marginTop: 0 }}>Az edge (Caddy) átveszi a 80/443-as portot az OpenResty-től: innentől minden domain rajta keresztül megy.</p>
        <ul className="a-site-checklist">
          <li className={edgeOk ? 'ok' : 'bad'}><span className="bx">{edgeOk ? '✓' : '✗'}</span><span>Az edge fut, teszt-módban{edgeOk ? '' : ` — most: ${!edge.installed ? 'nincs telepítve' : !edge.running ? 'nem fut' : 'már éles'}`}</span></li>
          {ITEMS.map((t, i) => (
            <li key={i} className={checks[i] ? 'ok' : ''}>
              <label><input type="checkbox" checked={checks[i]} onChange={(e) => setChecks(checks.map((c, j) => (j === i ? e.target.checked : c)))} /><span>{t}</span></label>
            </li>
          ))}
        </ul>
        <label className="a-site-field"><span>A megerősítéshez írd be: <b className="a-site-word">{WORD}</b></span>
          <input className="a-input mono" value={word} onChange={(e) => setWord(e.target.value.toUpperCase())} placeholder={WORD} autoComplete="off" /></label>
        {err && <div className="a-site-msg bad">{err}</div>}
        <div className="mt-4 flex gap-2">
          <button className="a-btn solid" disabled={!ready || busy} onClick={() => void go()}>{busy ? 'Átállás folyamatban…' : 'Átállás most'}</button>
          <button className="a-btn ghost" disabled={busy} onClick={onClose}>Mégse</button>
        </div>
      </div>
    </div>
  );
}
